// extracted by mini-css-extract-plugin
export default {"CommentActionsIconButton":"CommentActions-module__CommentActionsIconButton__sKptGw1","CommentActionsListItem":"CommentActions-module__CommentActionsListItem__Viwlyny"};